<script>
	import { fade } from 'svelte/transition';

	import { positions, variants, buttonTexts } from './data';
	import typografix from './typografix';

	// console.log(JSON.stringify(positions), JSON.stringify(variants))

	Object.defineProperty(Array.prototype, 'shuffle', {
		value: function() {
			return this.sort((a, b) => 0.5 - Math.random());
		}
	});

	Object.defineProperty(Array.prototype, 'random', {
		value: function() {
			return this[~~(Math.random() * this.length)];
		}
	});

	let position;
	let variant;

	const generateNewPosition = () => {

		position = positions.random();
		variant = variants.random();

		// position = positions.sort((a, b) => b.name.length - a.name.length)[0];
		// variant = variants.sort((a, b) => b.name.length - a.name.length)[0];
	}

	const formatVariant = (position, variant) => {
		if (position.feminine && variant.feminine) {
			return variant.feminine;
		}
		else if (position.plural && variant.plural) {
			return variant.plural;
		}
		return variant.name;
	}

	const appear = (node, { duration = 1000, delay }) => {
		const code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ&#*+%?£@§$ ';
		const text = node.textContent;
		
		let length = 0; 
		return {
			duration,
			delay,
			tick: (t) => {
				if (t < 0.5) {
					length = Math.min(Math.ceil(2.1 * t * text.length), text.length);
					const noise = Array.from({ length }, () => code.split('').random()).join('');				
					node.textContent = noise;
				}
				else if (t < 1) {
					const noise = node.textContent;
					const possibleIndexes = Array.from({ length: noise.length }, (_, i) => i)
						.filter(i => noise[i] !== text[i]).shuffle()
						.slice(0, 2);
					node.textContent = node.textContent.split('').map((c, i) => {
						if (c !== text[i] && !possibleIndexes.includes(i)) {
							return code.split('').random();
						}
						return text[i];
					}).join('');
				}
				else {
					node.textContent = text;
				}
			}
		};
	}

	generateNewPosition();
</script>

<article>
	<h1>Envie de tenter autre chose au lit&nbsp;? Pourquoi ne pas essayer...</h1>
	<div class='card'>
		{#key position, variant} 
			<h3 out:fade={{ duration: 400 }}>
				{#each position.name.split('\n') as line}
					<span in:appear={{ delay: 500 }}>
						{@html typografix(line)}
					</span>
					<br />
				{/each}
				<span in:appear={{ delay: 500 }}>
					{formatVariant(position, variant)}
				</span>
			</h3>
			<p
				in:fade={{ delay: 1500 }}
				out:fade={{ duration: 400 }}
			>
				{@html typografix(`${position.description} ${variant.description}`)}
			</p>
			<button
				in:fade={{ delay: 1500 }}
				out:fade={{ duration: 400 }}
				on:click={generateNewPosition}
			>
				{@html typografix(buttonTexts.random())}
			</button>
		{/key}
	</div>
</article>

<style lang='scss'>
	.card {
		margin: 2rem auto 0;
		display: flex;
		flex-direction: column;
		align-items: center;

		h3 {
			font: 600 1.8rem 'Fira Code', monospace;
			text-transform: uppercase;
			text-align: center;

			@media only screen and (max-width: 32rem) {
				font-size: 1.6rem;
			}

			span {
				white-space: pre;
			}
		}

		p {
			max-width: 24rem;
			margin: 0.5rem auto;
			text-align: center;
			color: var(--grey);
		}

		button {
			margin-top: 1rem;
			font-size: 1.1rem;

			&:hover {
				border: 2px solid var(--main-color);
			}
		}
	}

	:global(footer) {
		display: none;

		// position: absolute;
		// bottom: 0;
		// left: 50%;
		// transform: translateX(-50%);

		// @media only screen and (max-width: 32rem) {
		// 	display: none;
		// }
	}
	
</style>
